import React from 'react';
import {FaMinus, FaPlus} from "react-icons/fa6";

import css from './OrdersCounterModal.module.css';


const OrdersCounterModal = ({
                                days,
                                setDays,
                                setSelectedDates,
                                lastSelectedDate,
                                watchSat,
                                watchSun
                            }) => {
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const isDateActive = (date) => {
        if (watchSat && date.getDay() === 6) return false;
        if (watchSun && date.getDay() === 0) return false;
        return true;
    };

    const getNextDays = (count, startFrom = new Date()) => {
        const result = [];
        const start = new Date(startFrom);
        let i = 0;
        while (result.length < count) {
            const candidate = new Date(start);
            candidate.setDate(start.getDate() + i);
            if (isDateActive(candidate)) {
                result.push(formatDate(candidate));
            }
            i++;
        }
        return result;
    };

    const update = (newCount) => {
        const baseDate = lastSelectedDate || new Date();
        const newDates = getNextDays(newCount, baseDate);
        setDays(newCount);
        setSelectedDates(newDates);
    };

    const previous = () => {
        if (days > 1) update(days - 1);
    };

    const next = () => {
        if (days < 30) update(days + 1);
    };

    return (
        <div className={css.wrap}>
            <button type="button" className={css.btn} onClick={previous}>
                <FaMinus className={css.icon}/>
            </button>

            <div className={css.state}>{days}</div>

            <button type="button" className={css.btn} onClick={next}>
                <FaPlus className={css.icon}/>
            </button>
        </div>
    );
};

export {OrdersCounterModal};
